import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { SortParams } from 'shared/models/common';

import { PeriodValue } from './constants';

type EventsListState = {
  period: number;
  searchTerm: string;
  showOnlyUnreadMessages: boolean;
  sortParams: SortParams;
};

const initialState: EventsListState = {
  period: PeriodValue.All,
  searchTerm: '',
  sortParams: {
    order: 'desc',
    orderBy: 'CreatedOn',
    type: 'date',
  },
  showOnlyUnreadMessages: false,
};

const eventsListSlice = createSlice({
  name: 'events-list',
  initialState,
  reducers: {
    setPeriod: (state, action: PayloadAction<number>) => {
      state.period = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setSortParams: (state, action: PayloadAction<SortParams>) => {
      state.sortParams = action.payload;
    },
    setShowOnlyUnreadMessages: (state, action: PayloadAction<boolean>) => {
      state.showOnlyUnreadMessages = action.payload;
    },
    reset: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export default eventsListSlice.reducer;
export const {
  reset,
  setPeriod,
  setSearchTerm,
  setSortParams,
  setShowOnlyUnreadMessages,
} = eventsListSlice.actions;
